import { createContext } from 'react';
import { ProfileViewModel } from '@/components/profileDetail/Profile.ViewModel';

export const ProfileViewModelContext = createContext<ProfileViewModel>(
  {} as ProfileViewModel,
);
